module.exports = __webpack_public_path__ + "static/media/car-side.e7b39beb.svg";